export type DcTenantCode = 'au' | 'nz' | 'us' | 'global';
export type DcTenantTld = 'com.au' | 'co.nz' | 'com';

export interface DcTenant {
  readonly code: DcTenantCode;
  readonly name: DcTenantName;
  readonly tld: DcTenantTld;
}

type DcTenantName = 'Australia' | 'New Zealand' | 'United States' | 'Global';

const DC_TENANT_CONFIG: Record<DcTenantCode, Omit<DcTenant, 'code'>> = {
  au: {
    name: 'Australia',
    tld: 'com.au',
  },
  nz: {
    name: 'New Zealand',
    tld: 'co.nz',
  },
  us: {
    name: 'United States',
    tld: 'com',
  },
  global: {
    name: 'Global',
    tld: 'com',
  },
};

export function getTenantFromCode(code: DcTenantCode): DcTenant {
  const tenant = DC_TENANT_CONFIG[code];
  if (!tenant) {
    throw new Error(`Unsupported tenant code: ${code}`);
  }
  return { ...tenant, code };
}

//Not sure if any of this is necessary but it is in the original code
// class TenantHelpers {
//   public static fromString(code: DcTenantCode): DcTenant {
//     return getTenantFromCode(code);
//   }

//   public static equals(x: DcTenant | DcTenantCode, y: DcTenant | DcTenantCode): boolean {
//     if (typeof x === 'object' && x !== null && 'code' in x && typeof y === 'string') {
//       return x.code.toLowerCase() === y.toLowerCase();
//     }
//     if (typeof x === 'string' && typeof y === 'object' && y !== null && 'code' in y) {
//       return y.code.toLowerCase() === x.toLowerCase();
//     }
//     return false;
//   }

//   public static notEquals(x: DcTenant | DcTenantCode, y: DcTenant | DcTenantCode): boolean {
//     return !TenantHelpers.equals(x, y);
//   }

//   public static computeHash(str: string): number {
//     let hash = 0;
//     for (let i = 0; i < str.length; i++) {
//       // eslint-disable-next-line no-bitwise
//       hash = (hash * 31 + str.charCodeAt(i)) | 0;
//     }
//     return hash;
//   }
// }
